module.exports = __webpack_public_path__ + "img/thumbnail_GreySeal_f_albino.bff88bde.png";